var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgStatementDoc = function SvgStatementDoc(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.083 1.444H2.14v11.11h9.722V4.223H9.084l-.001-2.778ZM.75.744c0-.38.31-.69.694-.69h8.334l3.472 3.474v9.717a.694.694 0 0 1-.69.7H1.44a.695.695 0 0 1-.69-.69V.744Z",
    fill: "var(--color-primary-800)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M3.733 7.568V6.172h6.6v1.396h-6.6Zm-.066 2.5V8.672h6.666v1.396H3.667Z",
    fill: "var(--color-primary-800)"
  })));
};
export default SvgStatementDoc;